import React from 'react';
import {
    Button, CardBody, Card, Row, Col,
    Form,
    FormGroup, Label, FormText,
    Input,
    Container
} from 'reactstrap';
import { Link } from 'react-router-dom';
import BackButton from './BackButton'
import { Trans } from "react-i18next";

const OrganizationInfo = () => {
    return (
        <div>
            <Container>
                <Row>
                    <Col xs="12" md="12" sm="12">
                        <Card>

                            <CardBody className="">


                                <BackButton />
                                <h4 style={{ marginTop: "15px", marginBottom: "20px" }}><Trans>Organization Info</Trans></h4>

                                <Form className="form">

                                    <FormGroup className='mt-5'>
                                        <input type="file" id="upload-button" style={{ display: 'none' }}
                                        />

                                        <label htmlFor={'upload-button'}>
                                            <div className="chooseFile" style={{ backgroundColor: '#72B566', padding: '15px', borderRadius: '6px', color: '#fff' }}>
                                                <i className="fa fa-camera" aria-hidden="true"></i> Upload company logo
                                            </div>
                                        </label>

                                    </FormGroup>

                                    <Row>

                                        <Col className='col-md pr-0'>
                                            <FormGroup>
                                                <Label htmlFor="exampleEmail">Email Address</Label>
                                                <Input
                                                    type="email"
                                                    name="email"
                                                    id="emailAddress"
                                                    placeholder="Type here"
                                                />
                                            </FormGroup>

                                        </Col>



                                        <Col className='col-md pr-0'>

                                            <FormGroup >
                                                <Label htmlFor="Address">Address</Label>
                                                <Input
                                                    type="text"
                                                    name="Address"
                                                    id="Address"
                                                    placeholder="Type here"
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col className='col-md'>
                                            <FormGroup>
                                                <Label htmlFor="tel">Contact</Label>
                                                <Input
                                                    type="tel"
                                                    name="tel"
                                                    id="tel"
                                                    placeholder="Type here"
                                                />
                                            </FormGroup>

                                        </Col>



                                    </Row>
                                    <hr />







                                    <Button
                                        color="success"
                                        className="bt float-right " type="submit"
                                    >
                                        Add
                                    </Button>


                                </Form>

                            </CardBody>
                        </Card>
                    </Col>

                </Row>


            </Container>

        </div>
    );
}

export default OrganizationInfo;
